import React from 'react';
import ContentLoader from 'react-content-loader';
import './VehicleBuilderList.scss';

const VehicleBuilderListLoader = () => {
  return (
    <div className="vehicle-builder-loader_wrapper">
      <ContentLoader className="vehicle-builder-loader" height={200} speed={2}>
        <rect className="placeholder-rect-1" />
        <rect className="placeholder-rect-2" />
        <rect className="placeholder-rect-3" />
        <rect className="placeholder-rect-4" />
      </ContentLoader>
    </div>
  );
};

export default VehicleBuilderListLoader;



// WEBPACK FOOTER //
// ./src/components/molecules/VehicleBuilderList/VehicleBuilderListLoader.js